import { Injectable } from "@angular/core";
import { MatDatepickerIntl } from "@angular/material/datepicker";

/**
 * Los textos del calendario de Material en español: los que leen los
 * lectores de pantalla y los tooltips del calendario. Material los trae en
 * inglés y la app no los traducía, así que el botón del calendario se
 * anunciaba "Open calendar" en una pantalla toda en español.
 *
 * Uso, en los providers del componente que tiene el datepicker:
 *   { provide: MatDatepickerIntl, useClass: DatepickerIntlEs }
 */
@Injectable()
export class DatepickerIntlEs extends MatDatepickerIntl {
  override calendarLabel = "Calendario";
  override openCalendarLabel = "Abrir calendario";
  override closeCalendarLabel = "Cerrar calendario";
  override prevMonthLabel = "Mes anterior";
  override nextMonthLabel = "Mes siguiente";
  override prevYearLabel = "Año anterior";
  override nextYearLabel = "Año siguiente";
  override prevMultiYearLabel = "24 años anteriores";
  override nextMultiYearLabel = "24 años siguientes";
  override switchToMonthViewLabel = "Elegir fecha";
  override switchToMultiYearViewLabel = "Elegir mes y año";
  override startDateLabel = "Fecha inicial";
  override endDateLabel = "Fecha final";
  override comparisonDateLabel = "Periodo de comparación";

  override formatYearRangeLabel(start: string, end: string): string {
    return `${start} a ${end}`;
  }
}
